import React, { FC } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import Checkbox from '@mui/material/Checkbox'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import HelperText from './HelperText'
import { getProps } from './utils'

import {
  FormFieldProps,
} from '../../../../types/frontend/form'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    marginTop: theme.spacing(2),
  },
}))

const CheckboxField: FC<React.PropsWithChildren<FormFieldProps>> = (props) => {
  const {
    field: {
      name,
      value,
    },
    disabled,
    error,
    touched,
    item,
    readonly,
    form: {
      setFieldValue,
    },
  } = getProps(props)

  const classes = useStyles()
  const title = item.title || name

  const checkbox = (
    <FormControlLabel
      control={
        <Checkbox
          name={ name }
          checked={ value ? true : false }
          disabled={ readonly }
          onChange={ (e) => setFieldValue(name, e.target.checked) }
          value={ name }
        />
      }
      label={ title }
    />
  )

  return (
    <FormControl component="fieldset" className={ classes.root } disabled={ disabled }>
      {
        !item?.meta?.notitle && (
          <FormLabel component="legend">{ title }</FormLabel>
        )
      }
      <FormGroup>
        { checkbox }
      </FormGroup>
      <HelperText
        helperText={ item.helperText }
        error={ error ? true : false }
        touched={ touched }
      />
    </FormControl>
  )

}

export default CheckboxField